import Event from '../../core/Event';

export default class EstimationsDraftSaveRequested extends Event {
    public static type = 'EstimationsDraftSaveRequested';

    constructor() {
        super(EstimationsDraftSaveRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsDraftSaveRequested.ts